import { Component } from "react";
import { FormattedDate, FormattedMessage, injectIntl } from "react-intl";
import {
  ADMIN,
  RESPONDENT_EDITOR,
  ROLE_AD,
  ROLE_AD_AS,
  ROLE_BL,
  ROLE_RL,
  SURVEY_SUBMITTER,
  TEMPLATE_VIEWER,
  TEMPORARY_USER
} from "../../../common/constant";
import {
  CLOSED,
  IN_PROGRESS,
  NEW,
  OBSOLETE,
  SENT,
  SHOW_CHANGE_STATUS_SURVEY_DIALOG,
  SHOW_SEND_SURVEY_DIALOG,
  TOTAL_PROGRESS
} from "../../../ducks/statusOfSurvey";

import {
  faBinoculars,
  faCheck,
  faChevronLeft,
  faEdit,
  faEnvelope,
  faFileExport,
  faInfoCircle,
  faMagicWandSparkles,
  faPlayCircle,
  faPlus
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { ButtonGroup, ButtonToolbar, FormSelect } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import FormGroup from "react-bootstrap/FormGroup";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import ProgressBar from "react-bootstrap/ProgressBar";
import BootstrapTable from "react-bootstrap/Table";
import Tooltip from "react-bootstrap/Tooltip";
import { Link } from "react-router-dom";
import * as uuid from "uuid";
import { RespondentDetailsModel as rdModel, RespondentsOverviewModel as roModel } from "../../../common/entities";
import { SHOW_TEMP_USER_DIALOG } from "../../../ducks/manageSurveyTempUsers";
import { DETAILS } from "../../../ducks/respondentsOverview";
import ObjectUtils, { coalesce, getFullYearFromString } from "../../../utils/ObjectUtils";
import { hasMandatoryElements, isAnswered } from "../../../utils/QuestionUtils";
import SurveyUtils from "../../../utils/SurveyUtils";
import { isVisible, visibleCollection } from "../../../utils/TriggerUtil";
import StandardView from "../../common/StandardView";
import ManageSurveyTempUserContainer from "../../user/manageSurveyTempUser/ManageSurveyTempUserContainer";
import StatusOfSurveyContainer from "../../user/statusOfSurvey/StatusOfSurveyContainer";
import LockInfoDialog from "../respondentsOverview/LockInfoDialog";

/**
 * The component displays survey templates from the server.
 * When compoment was rendered, we will call server to load data.
 */
class RespondentDetail extends Component {
  constructor(props) {
    super(props);
    this.onChangeStausOfSurveyProperty = this.onChangeStausOfSurveyProperty.bind(this);
    this.onSortColumn = this.onSortColumn.bind(this);
    this.onChangeProperty = this.onChangeProperty.bind(this);
  }

  componentDidMount() {
    const { currentOverview, loadSurveyResult, loadSurveyVersion } = this.props;
    //We are triggering 'ducks' function, that will make a rest call and get data from the server.
    loadSurveyResult(currentOverview.reportPeriodGid);
    loadSurveyVersion(currentOverview, currentOverview, false, false);
  }

  calculateSum(details, property) {
    let propertySum = 0;
    for (let i = 0; i < details.length; i++) {
      propertySum = propertySum + (details[i][property] ? details[i][property] : 0);
    }
    return propertySum;
  }

  calculatePageProgress(details) {
    return Math.round((details.answeredQuestions / details.questions) * 100);
  }

  findPageForDetail(pages, detail) {
    const unique = (matches) => matches.length === 1 ? matches[0] : undefined;
    if (detail.pageKey) {
      return unique(pages.filter((page) => page.key === detail.pageKey));
    }
    const byName = pages.filter((page) => page.name === detail.pageName);
    if (byName.length) {
      return unique(byName);
    }

    // Older published sections used the title as their internal name.
    // Resolve against all pages so a hidden section cannot be mistaken for a visible namesake.
    const normalize = (value) => typeof value === "string" ? value.trim() : "";
    const legacyName = normalize(detail.pageName);
    if (!legacyName || legacyName !== normalize(detail.pageTitle)) {
      return undefined;
    }
    return unique(pages.filter((page) => normalize(page.title || page.name) === legacyName));
  }

  calculateProgress(questionsWithResult, pages, details) {
    const { triggerState } = this.props;
    // we have to pass trough
    for (let i = 0; i < details.length; i++) {
      details[i].answeredQuestions = 0;
      details[i].answeredMandatoryQuestions = 0;
      details[i].questions = 0;
      details[i].mandatoryQuestions = 0;

      //check is page visible
      const page = this.findPageForDetail(pages, details[i]);
      details[i].templatePageName = page?.name;
      const currentPage = isVisible(page, triggerState) ? page : {};
      currentPage.questions ? (details[i].visible = true) : (details[i].visible = false);

      // if page is visible
      if (currentPage.questions) {
        let visibleQuestions = visibleCollection(currentPage.questions, triggerState);
        for (let j = 0; j < visibleQuestions.length; j++) {
          let question = ObjectUtils.findByObjectProp(questionsWithResult, "name", visibleQuestions[j].name);
          if (
            visibleQuestions[j].type !== "infoMessage" &&
            visibleQuestions[j].type !== "projectData" &&
            visibleQuestions[j]
          ) {
            if (visibleQuestions[j].isRequired || hasMandatoryElements(visibleQuestions[j], question)) {
              //just visible questions for mandatory q.
              details[i].mandatoryQuestions = details[i].mandatoryQuestions + 1;
            }
            details[i].questions = details[i].questions + 1;
            if (question && isAnswered(visibleQuestions[j], question)) {
              details[i].answeredQuestions = details[i].answeredQuestions + 1;
              if (visibleQuestions[j].isRequired || hasMandatoryElements(visibleQuestions[j], question)) {
                details[i].answeredMandatoryQuestions = details[i].answeredMandatoryQuestions + 1;
              }
            }
          }
        }
      }
    }
  }

  calculateTotalProgress(details) {
    let answeredQuestions = 0;
    let questions = 0;
    for (let i = 0; i < details.length; i++) {
      if (details[i].visible) {
        answeredQuestions = answeredQuestions + details[i].answeredQuestions;
        questions = questions + details[i].questions;
      }
    }
    return isNaN(answeredQuestions / questions) ? 0 : (answeredQuestions / questions) * 100;
  }

  onChangeStausOfSurveyProperty(dialog, value, progress) {
    const { changeStatusOfSurveyProperty, loadAvailableWorkflowTransition } = this.props;
    changeStatusOfSurveyProperty(dialog, value);
    // wee need a total progress in popup for soft reminder when not 100% answered
    if (progress) {
      changeStatusOfSurveyProperty(TOTAL_PROGRESS, progress);
    }
    loadAvailableWorkflowTransition();
  }

  render() {
    const {
      details,
      currentOverview,
      sortTableTemplateBy,
      sortTableTemplateAscending,
      surveyResult,
      surveyTemplate,
      readOnly,
      intl,
      role,
      possibleTransitions,
      disableSentButton,
      showReadOnlyDialog,
      surveyName,
      lockByUser,
      lockFrom,
      hideReadOnlyDialog,
      editingDisabled,
      sapToken
    } = this.props;
    let TEMP_USER = role.includes(TEMPORARY_USER);
    let SUBMITTER = role.includes(SURVEY_SUBMITTER);
    let areaAdmin = currentOverview.roles?.includes(ADMIN);
    let RL = currentOverview.roles?.includes(ROLE_RL);
    let BL = currentOverview.roles?.includes(ROLE_BL);
    let AD = currentOverview.roles?.includes(ROLE_AD) || currentOverview.roles?.includes(ROLE_AD_AS);
    const isSemesterTypeProgram = SurveyUtils.isSemesterTypeProgram(currentOverview.program);
    let disabledMagicStick = editingDisabled && (BL || AD);
    let changingSentSurveyStateAllowed =
      (areaAdmin || role.includes(TEMPLATE_VIEWER)) &&
      possibleTransitions &&
      (possibleTransitions[CLOSED] || possibleTransitions[IN_PROGRESS]) &&
      currentOverview.status === SENT;
    let changingSurveyStateToObsoleteAllowed =
      areaAdmin &&
      possibleTransitions &&
      possibleTransitions[OBSOLETE] &&
      (currentOverview.status === NEW || currentOverview.status === IN_PROGRESS);
    // The details endpoint omits sections without questions, so the counts can differ.
    if (surveyResult.questions && surveyTemplate.pages) {
      this.calculateProgress(surveyResult.questions, surveyTemplate.pages, details);
    }

    // just to check is details not empty - then counting of progress can go
    let progress = details.length > 0 && details[0].pageGid ? Math.round(this.calculateTotalProgress(details)) : 0;
    let mandatoryQuestions = this.calculateSum(details, "mandatoryQuestions");
    let mandatoryQuestionsAnswered = this.calculateSum(details, "answeredMandatoryQuestions");
    let isSAPProject = "SAP" === currentOverview.projectCategory;
      const isEnabled = SUBMITTER && !readOnly && (!isSAPProject || sapToken);
      const tooltip =
      isEnabled ? (
        <Tooltip className="survey-tooltip" id="tooltip">
          <FormattedMessage id="respondents.detail.submit.button.tooltip" />
        </Tooltip>
      ) : (
        <Tooltip className="survey-tooltip" id="tooltip">
          <FormattedMessage id="respondents.detail.submit.button.disabled" />
        </Tooltip>
      );

    const actionButton = () => (
      <Button
        onClick={this.onChangeStausOfSurveyProperty.bind(this, SHOW_SEND_SURVEY_DIALOG, true, progress)}
        disabled={disableSentButton || !isEnabled || mandatoryQuestions !== mandatoryQuestionsAnswered}
      >
        <FontAwesomeIcon icon={faEnvelope} className="me-2" />
        {RL ? (
          <FormattedMessage id="respondents.detail.submitButton.RL" />
        ) : BL ? (
          <FormattedMessage id="respondents.detail.submitButton.BL" />
        ) : AD ? (
          <FormattedMessage id="respondents.detail.submitButton.AD" />
        ) : (
          <FormattedMessage id="respondents.detail.submitButton" />
        )}
      </Button>
    );

    function hasIncompleteRequiredQuestions() {
      for (let rdRow of details) {
        if (rdRow.answeredMandatoryQuestions < rdRow.mandatoryQuestions) {
          return true;
        }
      }

      return false;
    }

    //answeredMandatoryQuestions , mandatoryQuestions in details
    return (
      <StandardView
        id="detailsOverview"
        title={currentOverview[roModel.title]}
        actions={[
          {
            component: (
              <Button as={Link} to="/userArea/respondentsOverview" variant="secondary">
                <FontAwesomeIcon icon={faChevronLeft} size="sm" className="me-2" />
                <FormattedMessage id="respondents.overview.pageTitle" />
              </Button>
            )
          },
          {
            onClick: () => this.onSurveyPreview(),
            labelKey: editingDisabled ? "respondents.detail.run.survey.readOnly" : "respondents.detail.run.survey",
            icon: <FontAwesomeIcon icon={editingDisabled ? faBinoculars : faEdit} className="me-2" />
          }
        ]}
      >
        {showReadOnlyDialog && (
          <LockInfoDialog
            intl={intl}
            surveyName={surveyName}
            lockByUser={lockByUser}
            lockFrom={lockFrom}
            showReadOnlyDialog={showReadOnlyDialog}
            hideReadOnlyDialog={hideReadOnlyDialog}
          />
        )}
        <ManageSurveyTempUserContainer currentOverview={currentOverview} />
        <StatusOfSurveyContainer currentOverview={currentOverview} />
        <div className={"bg-light p-3 mb-3"}>
          <div className="survey-progress-bar mb-4">
            {progress + "% "}
            <FormattedMessage id="respondents.detail.progress" />
            <ProgressBar now={progress} />
          </div>
          <h6 className="project-name">
            {SurveyUtils.hasProjectForeignId(currentOverview)
              ? currentOverview[roModel.projectForeignId]
              : null}
            {" " + currentOverview[roModel.project]}
          </h6>
          <h6>
            <FormattedMessage id="respondents.overview.reportPeriod" />
            {`: ${SurveyUtils.getReportPeriodLabel(intl, currentOverview[roModel.program], getFullYearFromString(currentOverview[roModel.start]))}`}
          </h6>
          <h6>
            <FormattedMessage id="respondents.detail.status" />
            <FormattedMessage id={"respondents.detail.status." + currentOverview.status} />
            {!disabledMagicStick &&
              (changingSentSurveyStateAllowed || changingSurveyStateToObsoleteAllowed) &&
              (
                <Button
                  variant="link"
                  className="ms-3"
                  onClick={() => this.onChangeStausOfSurveyProperty(SHOW_CHANGE_STATUS_SURVEY_DIALOG, true, null)}
                  title={intl.formatMessage({ id: "respondents.detail.status.change" })}
                >
                  <FontAwesomeIcon icon={faMagicWandSparkles} />
                </Button>
              )}
          </h6>
          {SENT === currentOverview.status && currentOverview[roModel.lastSubmittedBy] && (
            <h6 className="edit-info">
              <FormattedMessage id="respondents.detail.submittedAt" />
              &nbsp;
              <FormattedDate
                value={new Date(currentOverview[roModel.lastSubmitted])}
                year="numeric"
                month="2-digit"
                day="2-digit"
              />
              &nbsp;
              <FormattedMessage id="respondents.detail.editBy" />
              &nbsp;
              {currentOverview[roModel.lastSubmittedBy]}
            </h6>
          )}
          <h6 className="edit-info">
            <FormattedMessage id="respondents.detail.lastEditAt" />
            &nbsp;
            {currentOverview[roModel.lastEdit] ? (
              <FormattedDate
                value={new Date(currentOverview[roModel.lastEdit])}
                year="numeric"
                month="2-digit"
                day="2-digit"
              />
            ) : (
              "-"
            )}
            &nbsp;
            <FormattedMessage id="respondents.detail.editBy" />
            &nbsp;
            {currentOverview.editedBy ? currentOverview.editedBy : "-"}
          </h6>

          {hasIncompleteRequiredQuestions() && (
            <h6 className="text-danger">
              <FormattedMessage id="respondents.detail.question.required.warning" />
            </h6>
          )}
        </div>
        <BootstrapTable striped hover responsive>
          <thead>
            <tr>
              <th
                className={SurveyUtils.addClassForTableHeader(
                  rdModel.pageName,
                  sortTableTemplateBy,
                  sortTableTemplateAscending
                )}
              >
                <Button variant="link" onClick={() => this.onSortColumn(rdModel.pageName, sortTableTemplateBy)}>
                  <FormattedMessage id="respondents.detail.page" />
                  {SurveyUtils.sortIcon(rdModel.pageName, sortTableTemplateBy, sortTableTemplateAscending)}
                </Button>
              </th>
              <th>
                <FormattedMessage id="respondents.detail.progress" />
              </th>
              <th className="text-center">
                <FormattedMessage id="respondents.detail.required.questions" />
              </th>
              { !isSemesterTypeProgram && <th
                className={SurveyUtils.addClassForTableHeader(
                  "respondentFullName",
                  sortTableTemplateBy,
                  sortTableTemplateAscending
                )}
              >
                <Button variant="link" onClick={() => this.onSortColumn("respondentFullName", sortTableTemplateBy)}>
                  <FormattedMessage id="respondents.detail.respondent" />
                  {SurveyUtils.sortIcon("respondentFullName", sortTableTemplateBy, sortTableTemplateAscending)}
                </Button>
              </th> }
              <th className="actions">
                <FormattedMessage id="app.common.title.actions" />
              </th>
            </tr>
          </thead>
          <tbody>{details.map(this.row.bind(this))}</tbody>
        </BootstrapTable>
        <ButtonToolbar className="w-100 justify-content-end">
          <ButtonGroup className="gap-lg">
            {!TEMP_USER ? (
              <>
                {role.includes(RESPONDENT_EDITOR) && (
                  <Button onClick={() => this.onChangeProperty(SHOW_TEMP_USER_DIALOG, true)} variant="secondary">
                    <FontAwesomeIcon icon={faPlus} className="me-2" />
                    <FormattedMessage id="respondents.detail.respondentenButton" />
                  </Button>
                )}
                <Button onClick={() => this.openPDF()} variant="secondary">
                  <FontAwesomeIcon icon={faFileExport} className="me-2" />
                  <FormattedMessage id="respondents.detail.pdf" />
                </Button>
                {!editingDisabled &&
                  (readOnly || !SUBMITTER || (isSAPProject && !sapToken) ? (
                    <OverlayTrigger placement="top" overlay={tooltip}>
                      {actionButton()}
                    </OverlayTrigger>
                  ) : mandatoryQuestions === mandatoryQuestionsAnswered ? (
                    actionButton()
                  ) : (
                    <OverlayTrigger placement="top" overlay={tooltip}>
                      {actionButton()}
                    </OverlayTrigger>
                  ))}
              </>
            ) : (
              <Button variant="secondary" onClick={() => this.openPDF()}>
                <FormattedMessage id="respondents.detail.pdf" />
              </Button>
            )}
          </ButtonGroup>
        </ButtonToolbar>
      </StandardView>
    );
  }

  /**
   * A row renderer
   */
  row(rdRow, i) {
    const { respondentList, details, sortTableTemplateBy, currentOverview } = this.props;
    const isSemesterTypeProgram = SurveyUtils.isSemesterTypeProgram(currentOverview.program);
    let projectLead = respondentList
      ? ObjectUtils.findByObjectProp(respondentList.respondentUsers, "role", "project_responsible").email
      : null;
    rdRow.respondentFullName = respondentList
      ? ObjectUtils.findByObjectProp(respondentList.respondentUsers, "email", coalesce(rdRow.userName, projectLead))
          .fullName
      : null;

    const questionsCompleted = rdRow.answeredMandatoryQuestions === rdRow.mandatoryQuestions;
    return rdRow.visible ? (
      <tr key={uuid.v4()}>
        <td className={SurveyUtils.addClassForTableColumns(rdModel.pageName, sortTableTemplateBy)}>
          {rdRow[rdModel.pageTitle] ? rdRow[rdModel.pageTitle] : rdRow[rdModel.pageName]}
        </td>
        <td className="text-truncate">
          {details[i].questions === 0 ? (
            <span className="no-questions">-</span>
          ) : (
            (this.calculatePageProgress(rdRow) ? this.calculatePageProgress(rdRow) : 0) + "%"
          )}
        </td>
        <td className="mandatory-questions text-center">
          {questionsCompleted ?
            <FontAwesomeIcon icon={faCheck} className="text-success ms-2" />
            :
            <div className="fw-bold text-danger">
            <FormattedMessage
            id="respondents.detail.progress.description"
            values={{
              count: rdRow.answeredMandatoryQuestions,
              total: rdRow.mandatoryQuestions
            }}
          /></div>
          }
        </td>
       {!isSemesterTypeProgram && <td className={SurveyUtils.addClassForTableColumns("respondentFullName", sortTableTemplateBy)}>
          <FormGroup  className="mb-3">
            <FormSelect
              name="respondent"
              disabled={"SENT" === currentOverview.status
                || "OBSOLETE" === currentOverview.status
                || "CLOSED" === currentOverview.status
              }
              onChange={(e) => {
                this.callShowModal(e, rdRow);
              }}
              value={coalesce(rdRow.userName, projectLead, "")}
            >
              {respondentList &&
                respondentList.respondentUsers.map((respondent, i) => {
                  return (
                    <option key={i} value={respondent.email}>
                      {respondent.fullName}
                    </option>
                  );
                })}
              ;
            </FormSelect>
          </FormGroup>
        </td> }
        <td className="text-truncate">
          <Button variant="link" onClick={() => this.onSurveyPagePreview(rdRow.templatePageName || rdRow[rdModel.pageName])}>
            <FontAwesomeIcon
              icon={faPlayCircle}
              className={!questionsCompleted ? "text-danger" : ""}
            />
          </Button>
        </td>
      </tr>
    ) : (
      false
    );
  }

  onSortColumn(columnType, sortTableTemplateBy) {
    const { sortTableTemplateAscending, sortColumn } = this.props;
    //triggers sorting.
    if (sortTableTemplateBy === columnType) {
      sortColumn(columnType, !sortTableTemplateAscending, DETAILS);
    } else {
      sortColumn(columnType, true, DETAILS);
    }
  }

  onChangeProperty(name, value) {
    const { loadTempUsers, changeProperty, currentOverview } = this.props;
    changeProperty(name, value);
    loadTempUsers(currentOverview.projectForeignId);
  }

  callShowModal(event, page) {
    const { showDialog, respondentForPagePropertyChange } = this.props;

    //when user click on delete, we are triggering [ducks].showDialog
    showDialog(
      page,
      respondentForPagePropertyChange,
      "respondents.detail.change.respondent",
      "respondents.detail.change.respondent.text",
      "confirmDialog.ok",
      "app.common.Cancel",
      <FontAwesomeIcon icon={faInfoCircle} size="2x" />
    );
    this.setNewValue(event);
  }

  setNewValue(event) {
    const { propertyChange } = this.props;
    propertyChange(event.target.name, event.target.value);
  }

  openPDF() {
    const { currentOverview, loadSurveyVersion } = this.props;
    //survey, historyVersion, link, push = true , createPDF = false, showPreview=false - default
    loadSurveyVersion(currentOverview, currentOverview, false, true, true, false);
  }

  onSurveyPagePreview(page) {
    const { currentOverview, lockInfoOfSurvey, propertyChange, isAdminUser, allowAdminEditing } = this.props;
    propertyChange("refreshDetailsPage", true);
    if (SurveyUtils.hasProjectForeignId(currentOverview)) {
      propertyChange("projectForeignId", currentOverview[roModel.projectForeignId]);
    } else {
      propertyChange("projectForeignId", null);
    }
    lockInfoOfSurvey(currentOverview, page, isAdminUser, allowAdminEditing);
  }

  onSurveyPreview() {
    const { currentOverview, lockInfoOfSurvey, propertyChange, isAdminUser, allowAdminEditing } = this.props;
    propertyChange("surveyCurrentPage", "");
    if (SurveyUtils.hasProjectForeignId(currentOverview)) {
      propertyChange("projectForeignId", currentOverview[roModel.projectForeignId]);
    } else {
      propertyChange("projectForeignId", null);
    }
    propertyChange("refreshDetailsPage", true);
    lockInfoOfSurvey(currentOverview, "", isAdminUser, allowAdminEditing);
  }
}

RespondentDetail.propTypes = {
  details: PropTypes.array,
  currentOverview: PropTypes.object,
  lockInfoOfSurvey: PropTypes.func,
  sortColumn: PropTypes.func,
  changeProperty: PropTypes.func,
  onChangeProperty: PropTypes.func,
  propertyChange: PropTypes.func,
  loadSurveyVersion: PropTypes.func,
  sortTableTemplateBy: PropTypes.string,
  sortTableTemplateAscending: PropTypes.bool,
  editedBy: PropTypes.object,
  respondentList: PropTypes.object,
  loadTempUsers: PropTypes.func,
  showDialog: PropTypes.func,
  respondentForPagePropertyChange: PropTypes.func,
  role: PropTypes.array,
  loadSurveyResult: PropTypes.func,
  surveyResult: PropTypes.object,
  surveyTemplate: PropTypes.object,
  closed: PropTypes.bool,
  inProgress: PropTypes.bool,
  obsolete: PropTypes.bool,
  isAdminUser: PropTypes.bool,
  new: PropTypes.bool,
  triggerState: PropTypes.array,
  intl: PropTypes.object,
  changeStatusOfSurveyProperty: PropTypes.func,
  loadAvailableWorkflowTransition: PropTypes.func,
  surveyName: PropTypes.string,
  lockFrom: PropTypes.number,
  lockByUser: PropTypes.string,
  readOnly: PropTypes.bool,
  showReadOnlyDialog: PropTypes.bool,
  hideReadOnlyDialog: PropTypes.func
};

export default injectIntl(RespondentDetail);
